import { render } from "./VBCSSOCallback.vue?vue&type=template&id=700af1c0&scoped=true"
import script from "./VBCSSOCallback.vue?vue&type=script&lang=js"
export * from "./VBCSSOCallback.vue?vue&type=script&lang=js"

import "./VBCSSOCallback.vue?vue&type=style&index=0&id=700af1c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700af1c0"]])

export default __exports__